import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getAdminInfo } from "../../api/auth";
import { User } from "../../types/types";
import { isRewindDefaultHost } from "../../utils/cmsHost";
import s from "./AdminSidebar.module.css";

const AdministrationSidebar: React.FC = () => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const location = useLocation();
    const [user, setUser] = useState<User | null>(null);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const token = localStorage.getItem("token");
                if (token) {
                    const userData = await getAdminInfo({ token });
                    setUser(userData as User);
                }
            } catch (error) {
                console.error("Error fetching user info:", error);
            }
        };
        fetchUser();
    }, []);

    const navLinks: { name: string; path: string }[] = [
        { name: t("cities"), path: "/administration/cities" },
        { name: t("tourCategories"), path: "/administration/categories" },
        { name: t("companies"), path: "/administration/companies" },
        { name: t("users"), path: "/administration/users" },
        ...(user?.isOwner ? [{ name: t("appUsers"), path: "/administration/app-users" }] : []),
        ...(user?.isOwner ? [{ name: t("walkingTourSwitch"), path: "/administration/walking-tour-switch" }] : []),
        { name: t("prompts"), path: "/administration/prompts" },
        { name: t("voices"), path: "/administration/voices" },
        { name: t("soundLibrary"), path: "/administration/sounds" },
        { name: t("businessCatalogs"), path: "/administration/businessCatalogs" },
        { name: t("languages"), path: "/administration/languages" },
        ...(user?.isOwner && isRewindDefaultHost() ? [{ name: t("apiKeys"), path: "/administration/api-keys" }] : []),
    ];

    return (
        <aside className={s.root}>
            <h2 className={s.title}>{t("administration")}</h2>
            <p className={s.section}>{t("manage")}</p>
            <ul className={s.nav}>
                {navLinks.map((link) => (
                    <li key={link.path} className={`${s.item} ${location.pathname === link.path ? s.active : ""}`}>
                        <Link className={s.link} to={link.path}>
                            {link.name}
                        </Link>
                    </li>
                ))}
            </ul>
        </aside>
    );
};

export default AdministrationSidebar;
